import { OPERATION_REQUEST_MODES } from "./operationRequestConstants.js";

const STORAGE_KEY = "hr_op_req_name_change_draft_v1";

/**
 * @param {{
 *   routeState: { mode: string, selectedOrder: object, requestType?: string | null },
 *   form: {
 *     nameChangePassengerId: string | number | null,
 *     nameChangeNewFirst: string,
 *     nameChangeNewLast: string,
 *     message: string,
 *   },
 * }} p
 */
export function saveNameChangeOperationDraft({ routeState, form }) {
  try {
    const payload = {
      v: 1,
      savedAt: Date.now(),
      routeState: {
        mode: OPERATION_REQUEST_MODES.operation_request,
        selectedOrder: routeState.selectedOrder,
        requestType: "name_change",
      },
      form: {
        nameChangePassengerId: form.nameChangePassengerId ?? null,
        nameChangeNewFirst: String(form.nameChangeNewFirst ?? ""),
        nameChangeNewLast: String(form.nameChangeNewLast ?? ""),
        message: String(form.message ?? ""),
      },
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    return true;
  } catch {
    return false;
  }
}

/** @returns {{ routeState: object, form: object } | null } */
export function loadNameChangeOperationDraft() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p || p.v !== 1 || !p.routeState?.selectedOrder) return null;
    return { routeState: p.routeState, form: p.form || {} };
  } catch {
    return null;
  }
}

export function clearNameChangeOperationDraft() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * מצב ניווט מלא לעמוד פנייה מחדש אחרי תשלום
 * @param {{ routeState: object, form: object }} draft
 */
export function buildNavigateStateFromNameChangeDraft(draft) {
  if (!draft?.routeState) return null;
  return {
    ...draft.routeState,
    requestType: "name_change",
    _nameChangeFormRestore: draft.form || null,
  };
}
